import { TIMELINE } from "../lib/constants";

export const Timeline = () => {
  return (
    <section
      id="timeline"
      data-testid="timeline-section"
      className="relative bg-[#FDFBF7] py-20 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center mb-20 reveal max-w-3xl mx-auto">
          <div className="flex items-center justify-center gap-4 mb-2">
            <span className="gold-line" />
            <span className="font-sans text-[#0B2545] uppercase text-2xl md:text-3xl lg:text-4xl tracking-widest-2 font-semibold">
              Milestones
            </span>
            <span className="gold-line" />
          </div>
        </div>

        <div className="relative">
          {/* Vertical gold line */}
          <div className="absolute left-5 md:left-1/2 top-0 bottom-0 w-px bg-[#C8A24A]/40 md:-translate-x-px" />

          <ol className="space-y-12 md:space-y-20">
            {TIMELINE.map((item, i) => {
              const left = i % 2 === 0;
              return (
                <li
                  key={item.year}
                  data-testid={`timeline-item-${i}`}
                  className="relative reveal"
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  {/* Node */}
                  <span className="absolute left-5 md:left-1/2 -translate-x-1/2 top-2 w-3.5 h-3.5 bg-[#C8A24A] ring-4 ring-[#FDFBF7]" />

                  <div
                    className={`pl-14 md:pl-0 grid md:grid-cols-2 md:gap-16 ${
                      left ? "" : "md:[&>*:first-child]:order-2"
                    }`}
                  >
                    {/* Year */}
                    <div
                      className={`md:px-10 ${
                        left ? "md:text-right" : "md:text-left"
                      }`}
                    >
                      <div className="font-serif text-[#0B2545] text-5xl md:text-6xl font-semibold leading-none">
                        {item.year}
                      </div>
                    </div>
                    {/* Body */}
                    <div className="md:px-10 mt-3 md:mt-2">
                      <h3 className="font-serif text-[#0B2545] text-xl md:text-2xl mb-3">
                        {item.title}
                      </h3>
                      <p className="font-sans text-[#061426]/75 text-base leading-relaxed">
                        {item.body}
                      </p>
                    </div>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
};
